import { styled, Typography } from "@mui/material";
import { HeadingStyles, SPACING } from "../theme/palette";
const ContainerStyle = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.background.paper,
    "paddingBlock": SPACING.space2xl,
}));
const ContainerStyleWhite = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.background.default,
    "paddingBlock": SPACING.space2xl,
}));
const ContainerLargeStyleWhite = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.background.default,
    "paddingBlock": SPACING.space2xl,
}));
const HeadingStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h2), { "color": theme.palette.primary.dark, "fontWeight": 650, "textAlign": "center" })));
const FreeTrailHeadingStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h2), { "fontWeight": 350, "textAlign": "left" })));
const FreeTrailRow = styled("div")(() => ({
    "alignItems": " flex-start",
    "display": "flex",
    "flexDirection": "column",
    "gap": SPACING.spacexs
}));
const NameStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h4), { "color": theme.palette.primary.dark, "fontWeight": 650 })));
const JobPositionStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.subtitle1), { "marginBottom": SPACING.spaces, "marginTop": SPACING.space2xs })));
const SectionTextStyle = styled("div")(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h6), { "div": {
        ">*": {
            "marginBottom": SPACING.spacexs,
            "marginTop": 0,
        },
        "a": {
            "color": theme.palette.common.white,
            "textDecoration": "Underline"
        },
        "display": "flex",
        "flexDirection": "column",
        "gap": SPACING.spacexs,
        "h1": Object.assign({}, HeadingStyles.h2),
        "h2": Object.assign({}, HeadingStyles.h3),
        "h3": Object.assign({}, HeadingStyles.h4)
    }, "lineHeight": 1.75 })));
const SectionBlueHeadingTextStyle = styled(SectionTextStyle)(({ theme }) => ({
    "div": {
        "h1, h2, h3, h4, h5, h6": {
            "color": theme.palette.primary.dark,
        },
    }
}));
const ImageSectionStyle = styled("div")(() => ({
    "height": "100%",
    "img": {
        "width": "100%",
    },
    "width": "100%"
}));
export { ContainerLargeStyleWhite, ContainerStyle, ContainerStyleWhite, FreeTrailHeadingStyle, FreeTrailRow, HeadingStyle, ImageSectionStyle, JobPositionStyle, NameStyle, SectionBlueHeadingTextStyle, SectionTextStyle };
